import { Badge, Button, Card, ListGroup } from 'react-bootstrap';
import { FaCheck } from 'react-icons/fa';

/**
 * Card para exibir informações de um plano - Design Minimalista para Advogados
 */
export const PlanCard = ({ 
  plan, 
  isCurrentPlan, 
  isOnTrial, 
  isPendingCancellation,
  hasAnyPendingCancellation,
  hasRequiredData = true,
  onSelect, 
  isLoading,
  highlighted = false
}) => {
  const planNames = {
    1: 'Free',
    2: 'Starter',
    3: 'Professional',
    4: 'Enterprise',
    5: 'Custom'
  };

  const planSubtitles = {
    1: 'Teste gratuitamente',
    2: 'Ideal para advogados autônomos',
    3: 'Para escritórios em crescimento',
    4: 'Para grandes escritórios',
    5: 'Plano personalizado'
  };

  const planPrices = {
    1: 0,
    2: 89.99,
    3: 149.99,
    4: 249.99,
    5: 500,
  };

  const formatStorage = (bytes) => {
    const gb = bytes / (1024 ** 3);
    return gb >= 1000 ? 'Ilimitado' : `${gb.toFixed(0)} GB`;
  };

  const formatNumber = (num) => {
    return num >= 999999 ? 'Ilimitado' : num;
  };

  return (
    <Card
      className="plan-card h-100"
      style={{
        background: "#2a2a2a",
        border: `2px solid ${highlighted ? "#d4af37" : "#3a3a3a"}`,
        borderRadius: "16px",
        transition: "all 0.3s ease",
        position: "relative",
        boxShadow: "none",
      }}
    >
      {/* Badge de Mais Popular */}
      {highlighted && (
        <div
          className="position-absolute top-0 start-50 translate-middle"
          style={{ zIndex: 10 }}
        >
          <Badge
            style={{
              background: "#d4af37",
              color: "#000",
              padding: "0.5rem 1.25rem",
              fontSize: "0.75rem",
              fontWeight: "600",
              borderRadius: "20px",
              textTransform: "uppercase",
              letterSpacing: "0.5px",
            }}
            bg="#d4af37"
          >
            MAIS POPULAR
          </Badge>
        </div>
      )}

      <Card.Body
        className="d-flex flex-column"
        style={{ padding: highlighted ? "3rem 2rem 2rem" : "2.5rem 2rem 2rem" }}
      >
        {/* Nome do Plano */}
        <h3
          style={{
            color: "#fff",
            fontWeight: "600",
            fontSize: "1.5rem",
            marginBottom: "0.5rem",
            textAlign: "center",
          }}
        >
          {planNames[plan.id]}
        </h3>

        {/* Subtítulo */}
        <p
          style={{
            color: "#999",
            fontSize: "0.9rem",
            textAlign: "center",
            marginBottom: "2rem",
          }}
        >
          {planSubtitles[plan.id]}
        </p>

        {/* Badges de Status */}
        {(isCurrentPlan || isOnTrial || isPendingCancellation) && (
          <div className="text-center mb-3">
            {isCurrentPlan && !isPendingCancellation && (
              <Badge
                bg="success"
                className="me-2"
                style={{
                  fontSize: "0.7rem",
                  padding: "0.35rem 0.7rem",
                  fontWeight: "500",
                }}
              >
                Plano Atual
              </Badge>
            )}
            {isPendingCancellation && (
              <Badge
                bg="warning"
                text="dark"
                className="me-2"
                style={{
                  fontSize: "0.7rem",
                  padding: "0.35rem 0.7rem",
                  fontWeight: "500",
                }}
              >
                Cancelamento Agendado
              </Badge>
            )}
            {isOnTrial && isCurrentPlan && !isPendingCancellation && (
              <Badge
                bg="warning"
                text="dark"
                style={{
                  fontSize: "0.7rem",
                  padding: "0.35rem 0.7rem",
                  fontWeight: "500",
                }}
              >
                Em Trial
              </Badge>
            )}
          </div>
        )}

        {/* Preço */}
        <div className="text-center mb-4">
          <div
            style={{
              display: "flex",
              alignItems: "baseline",
              justifyContent: "center",
              gap: "0.25rem",
            }}
          >
            <span
              style={{
                color: "#999",
                fontSize: "1.25rem",
                fontWeight: "400",
              }}
            >
              R$
            </span>
            <span
              style={{
                color: "#d4af37",
                fontSize: "3rem",
                fontWeight: "700",
                lineHeight: "1",
              }}
            >
              {Math.floor(planPrices[plan.id])}
            </span>
            <span
              style={{
                color: "#d4af37",
                fontSize: "1.5rem",
                fontWeight: "700",
              }}
            >
              ,{(planPrices[plan.id] % 1).toFixed(2).substring(2)}
            </span>
          </div>
          <div
            style={{
              color: "#999",
              fontSize: "0.85rem",
              fontWeight: "400",
              marginTop: "0.5rem",
            }}
          >
            /mês
          </div>
        </div>

        {/* Botão de Ação */}
        <div className="mb-4">
          {!isCurrentPlan && plan.id !== 1 && hasRequiredData && !hasAnyPendingCancellation && (
            <Button
              className="w-100"
              size="lg"
              onClick={() => onSelect(plan.id)}
              disabled={isLoading}
              style={{
                background: highlighted ? "#d4af37" : "transparent",
                border: `2px solid #d4af37`,
                color: highlighted ? "#000" : "#d4af37",
                fontWeight: "600",
                fontSize: "0.95rem",
                padding: "0.875rem",
                borderRadius: "8px",
                transition: "all 0.3s ease",
              }}
              onMouseEnter={(e) => {
                if (!highlighted) {
                  e.currentTarget.style.background = "#d4af37";
                  e.currentTarget.style.color = "#000";
                }
              }}
              onMouseLeave={(e) => {
                if (!highlighted) {
                  e.currentTarget.style.background = "transparent";
                  e.currentTarget.style.color = "#d4af37";
                }
              }}
            >
              {isLoading ? "Processando..." : "Assinar Agora"}
            </Button>
          )}
          {isCurrentPlan && !isOnTrial && !isPendingCancellation && (
            <Button
              className="w-100"
              disabled
              style={{
                background: "transparent",
                border: "2px solid #3a3a3a",
                color: "#666",
                fontWeight: "600",
                fontSize: "0.95rem",
                padding: "0.875rem",
                borderRadius: "8px",
              }}
            >
              Plano Ativo
            </Button>
          )}
          {isPendingCancellation && (
            <Button
              className="w-100"
              disabled
              style={{
                background: "transparent",
                border: "2px solid #f0ad4e",
                color: "#f0ad4e",
                fontWeight: "600",
                fontSize: "0.95rem",
                padding: "0.875rem",
                borderRadius: "8px",
              }}
            >
              Cancelamento Agendado
            </Button>
          )}
          {!isCurrentPlan && plan.id !== 1 && hasAnyPendingCancellation && !isPendingCancellation && (
            <Button
              className="w-100"
              disabled
              style={{
                background: "transparent",
                border: "2px solid #666",
                color: "#666",
                fontWeight: "600",
                fontSize: "0.95rem",
                padding: "0.875rem",
                borderRadius: "8px",
              }}
            >
              Upgrade Bloqueado
            </Button>
          )}
          {!isCurrentPlan && plan.id !== 1 && !hasRequiredData && (
            <Button
              className="w-100"
              disabled
              style={{
                background: "transparent",
                border: "2px solid #dc3545",
                color: "#dc3545",
                fontWeight: "600",
                fontSize: "0.95rem",
                padding: "0.875rem",
                borderRadius: "8px",
              }}
            >
              Complete seu Perfil
            </Button>
          )}
          {plan.id === 1 && !isCurrentPlan && (
            <Button
              className="w-100"
              disabled
              style={{
                background: "transparent",
                border: "2px solid #3a3a3a",
                color: "#666",
                fontWeight: "600",
                fontSize: "0.95rem",
                padding: "0.875rem",
                borderRadius: "8px",
              }}
            >
              Plano Gratuito
            </Button>
          )}
        </div>

        {/* Features */}
        <ListGroup variant="flush" className="flex-grow-1">
          <ListGroup.Item
            style={{
              background: "transparent",
              border: "none",
              padding: "0.65rem 0",
              color: "#ccc",
              fontSize: "0.9rem",
              display: "flex",
              alignItems: "center",
            }}
          >
            <FaCheck
              style={{
                color: "#d4af37",
                marginRight: "0.75rem",
                fontSize: "0.85rem",
              }}
            />
            <div>
              <strong style={{ color: "#fff" }}>
                {formatNumber(plan.users_registered)}
              </strong>
              <span style={{ marginLeft: "0.35rem" }}>
                usuário{plan.users_registered > 1 ? "s" : ""}
              </span>
            </div>
          </ListGroup.Item>
          <ListGroup.Item
            style={{
              background: "transparent",
              border: "none",
              padding: "0.65rem 0",
              color: "#ccc",
              fontSize: "0.9rem",
              display: "flex",
              alignItems: "center",
            }}
          >
            <FaCheck
              style={{
                color: "#d4af37",
                marginRight: "0.75rem",
                fontSize: "0.85rem",
              }}
            />
            <div>
              <strong style={{ color: "#fff" }}>
                {formatNumber(plan.lawsuits_registered)}
              </strong>
              <span style={{ marginLeft: "0.35rem" }}>
                processos cadastrados
              </span>
            </div>
          </ListGroup.Item>
          <ListGroup.Item
            style={{
              background: "transparent",
              border: "none",
              padding: "0.65rem 0",
              color: "#ccc",
              fontSize: "0.9rem",
              display: "flex",
              alignItems: "center",
            }}
          >
            <FaCheck
              style={{
                color: "#d4af37",
                marginRight: "0.75rem",
                fontSize: "0.85rem",
              }}
            />
            <div>
              <strong style={{ color: "#fff" }}>
                {formatStorage(plan.cloud_storage)}
              </strong>
              <span style={{ marginLeft: "0.35rem" }}>
                de armazenamento em nuvem
              </span>
            </div>
          </ListGroup.Item>
          <ListGroup.Item
            style={{
              background: "transparent",
              border: "none",
              padding: "0.65rem 0",
              color: "#ccc",
              fontSize: "0.9rem",
              display: "flex",
              alignItems: "center",
            }}
          >
            <FaCheck
              style={{
                color: "#d4af37",
                marginRight: "0.75rem",
                fontSize: "0.85rem",
              }}
            />
            <div>
              <strong style={{ color: "#fff" }}>
                {formatNumber(plan.captured_names)}
              </strong>
              <span style={{ marginLeft: "0.35rem" }}>
                nomes de busca diária
              </span>
            </div>
          </ListGroup.Item>
          <ListGroup.Item
            style={{
              background: "transparent",
              border: "none",
              padding: "0.65rem 0",
              color: "#ccc",
              fontSize: "0.9rem",
              display: "flex",
              alignItems: "center",
            }}
          >
            <FaCheck
              style={{
                color: "#d4af37",
                marginRight: "0.75rem",
                fontSize: "0.85rem",
              }}
            />
            <div>
              <strong style={{ color: "#fff" }}>
                {formatNumber(plan.monitored_lawsuits)}
              </strong>
              <span style={{ marginLeft: "0.35rem" }}>
                processos monitorados
              </span>
            </div>
          </ListGroup.Item>
          <ListGroup.Item
            style={{
              background: "transparent",
              border: "none",
              padding: "0.65rem 0",
              color: "#ccc",
              fontSize: "0.9rem",
              display: "flex",
              alignItems: "center",
            }}
          >
            <FaCheck
              style={{
                color: "#d4af37",
                marginRight: "0.75rem",
                fontSize: "0.85rem",
              }}
            />
            <span>Chat interno</span>
          </ListGroup.Item>
          <ListGroup.Item
            style={{
              background: "transparent",
              border: "none",
              padding: "0.65rem 0",
              color: "#ccc",
              fontSize: "0.9rem",
              display: "flex",
              alignItems: "center",
            }}
          >
            <FaCheck
              style={{
                color: "#d4af37",
                marginRight: "0.75rem",
                fontSize: "0.85rem",
              }}
            />
            <span>Timesheet</span>
          </ListGroup.Item>
          <ListGroup.Item
            style={{
              background: "transparent",
              border: "none",
              padding: "0.65rem 0",
              color: "#ccc",
              fontSize: "0.9rem",
              display: "flex",
              alignItems: "center",
            }}
          >
            <FaCheck
              style={{
                color: "#d4af37",
                marginRight: "0.75rem",
                fontSize: "0.85rem",
              }}
            />
            <span>Utilização em celular</span>
          </ListGroup.Item>
          {plan.id >= 3 && (
            <ListGroup.Item
              style={{
                background: "transparent",
                border: "none",
                padding: "0.65rem 0",
                color: "#ccc",
                fontSize: "0.9rem",
                display: "flex",
                alignItems: "center",
              }}
            >
              <FaCheck
                style={{
                  color: "#d4af37",
                  marginRight: "0.75rem",
                  fontSize: "0.85rem",
                }}
              />
              <span>Suporte gratuito</span>
            </ListGroup.Item>
          )}
        </ListGroup>
      </Card.Body>
    </Card>
  );
};
